import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import consts from "../../constant";

const url = `${consts?.BackendUrl}`;


//get Stake Currency with user balance 
export const getStakeCurrency = createAsyncThunk(
    "staking/getStaking", // ✅ Unique action type under
    async (_, { rejectWithValue }) => {

        try {
            const response = await axios.get(`${url}/staking/getStaking`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed To Get Payment Method");
        }
    }
);


//create User Staking
export const createUserStake = createAsyncThunk(
    "staking/createUserStaking", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/staking/createUserStaking`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });

            if (!response?.data?.success) {
                return rejectWithValue(response?.data || "Failed To Add Payment Method");
            }

            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To Add Payment Method");
        }
    }
);


//create User Staking History
export const getUserStakeHistory = createAsyncThunk(
    "staking/UserStakingHistory", // ✅ Unique action type under
    async (_, { rejectWithValue }) => {

        try {
            const response = await axios.get(`${url}/staking/UserStakingHistory`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed To Get Payment Method");
        }
    }
);


const stakeSlice = createSlice({
    name: "stake",
    initialState: {
        stake: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // get stake currency method
            .addCase(getStakeCurrency?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getStakeCurrency.fulfilled, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getStakeCurrency.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.payload;
            })
    },
});





export default stakeSlice.reducer;
